import { Icon } from '@acpaas-ui/react-components';
import { SIDEBAR_TABS } from '../../constants/settings.constants';

const infoIcon = (active) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Icon/Activities</title>
    <g
      id="Icon/Activities"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Icon-Color" transform="translate(1.000000, 1.000000)" stroke={active ? '#0057b7' : '#7D7D7D'}>
        <path
          d="M11,22 C17.075,22 22,17.075 22,11 C22,4.925 17.075,0 11,0 C4.925,0 0,4.925 0,11 C0,17.075 4.925,22 11,22 Z"
          id="Stroke-2633"
        ></path>
        <path
          d="M13.5,16.0098 L12,16.0098 C11.447,16.0098 11,15.5628 11,15.0098 L11,8.5098 C11,8.2338 10.776,8.0098 10.5,8.0098 L9,8.0098"
          id="Stroke-2635"
        ></path>
        <path
          d="M10.7451,5.5 C10.6061,5.5 10.4951,5.612 10.4951,5.75 C10.4951,5.888 10.6061,6 10.7451,6 C10.8831,6 10.9951,5.888 10.9951,5.75 C10.9951,5.612 10.8831,5.5 10.7451,5.5"
          id="Stroke-2637"
        ></path>
      </g>
    </g>
  </svg>
);

const conversationIcon = (active) => (
  <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Icon/Conversation0</title>
    <g
      id="Icon/Conversation"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Group" transform="translate(1.000000, 1.000000)" stroke={active ? '#0057b7' : '#7D7D7D'}>
        <path
          d="M14,0 L4,0 C1.791,0 0,1.791 0,4 L0,9 C0,11.21 1.791,13 4,13 L5,13 L5,17 L9.5,13 L14,13 C16.209,13 18,11.21 18,9 L18,4 C18,1.791 16.209,0 14,0 Z"
          id="Stroke-1161"
        ></path>
        <path
          d="M11,16 L11,17.5 C11,18.163 11.263,18.8 11.732,19.269 C12.201,19.737 12.837,20 13.5,20 L16,20 L19,23 L19,20 L20.5,20 C21.163,20 21.799,19.737 22.268,19.269 C22.737,18.8 23,18.163 23,17.5 L23,14.5 C23,13.12 21.881,12 20.5,12 L20,12"
          id="Stroke-1163"
        ></path>
      </g>
    </g>
  </svg>
);

const DossierSidebarNav = ({ openedTab, commentsCount, onNavClick, onCollapseClick }) => {
  return (
    <nav className="spo-o-dossier-sidebar__nav">
      <ul className="a-list a-list--unstyled u-text-light u-text-center">
        <li
          className={openedTab === SIDEBAR_TABS.ACTIVITY ? 'active u-text-primary' : ''}
          onClick={() => onNavClick(SIDEBAR_TABS.ACTIVITY)}
        >
          {infoIcon(openedTab === SIDEBAR_TABS.ACTIVITY)}
        </li>
        <li
          className={openedTab === SIDEBAR_TABS.COMMENTS ? 'active u-text-primary' : ''}
          onClick={() => onNavClick(SIDEBAR_TABS.COMMENTS)}
        >
          {conversationIcon(openedTab === SIDEBAR_TABS.COMMENTS)}
          {!!commentsCount && <span className="comments-count">{commentsCount}</span>}
        </li>
        {!!openedTab && (
          <li className="collapse" onClick={onCollapseClick}>
            <Icon name="ai-logout-1" />
          </li>
        )}
      </ul>
    </nav>
  );
};

export default DossierSidebarNav;
